import { Component, Input, OnInit } from '@angular/core';
import { BaseCommonComponent, BaseDataService, BaseModalContainer, ModalContainerService, ModalService, NotificationService, QueryParameter, UserService } from 'yt-ng-framework';
import { UserNapomena } from './user-napomena';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-napomena',
  templateUrl: './user-napomena.component.html'
})
export class UserNapomenaComponent extends BaseCommonComponent implements OnInit {

  constructor(        
    protected activatedRoute: ActivatedRoute,
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected userService: UserService,
    protected modalService: ModalService)
    {
      super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
     }

     ID: number;
     userID: any;
     napomena: any;
     @Input() Parameters: QueryParameter[];
     postoji: boolean = false;

  ngOnInit() {
    this.baseFormGroup = new FormGroup({
      ID: new FormControl(),
      UserID : new FormControl(),
      Napomena : new FormControl("")
    })

    this.userID = this.Parameters[0].Value;

    this.baseDataService.Get('UserNapomena', 'GetByUserId', [new QueryParameter('userID', this.userID)], UserNapomena)
      .subscribe(data => {
        if(data){
          this.postoji = true;
          this.baseFormGroup.patchValue({ID: data[0].ID});
          this.baseFormGroup.get('ID').updateValueAndValidity();
          this.baseFormGroup.patchValue({Napomena: data[0].Napomena});
          this.baseFormGroup.get('Napomena').updateValueAndValidity();
        }else{
          this.baseFormGroup.patchValue({ID: -1});
          this.baseFormGroup.get('ID').updateValueAndValidity();
        }
      })
  }

  Save(){

    this.napomena = this.baseFormGroup.get('Napomena').value;
    this.ID = this.baseFormGroup.get('ID').value;
    let parameters = { ID: this.ID, userID: this.userID, napomena: this.napomena};

    this.baseDataService.Post('UserNapomena', 'Post', parameters, null)
    .subscribe(() => {
      // this.notificationService.success('Uspešno', 'Sačuvan');
      this.toastrService.success('Uspešno', 'Sačuvan');
    })
  
    this.activeModal.close();
  }

  Close(){
    this.activeModal.dismiss();
}

}
